import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// TODO: fix all the "any" typing in this page
import React, { useEffect, useState, useMemo } from 'react';
import styles from './DistributionPanel.module.css';
import DistributionPanelMainBreaker from '../DistributionPanelMainBreaker';
import CircuitBreaker from '../CircuitBreaker';
import EnergyPro from '../EnergyPro';
import EnergyBar from '../EnergyBar';
import EnergySpider from '../EnergySpider';
import EnergySpiderFlex from '../EnergySpiderFlex';
import { getBreakerPolePosition, getMainBreakerPolePosition, getBreakerPosition, getDeviceHeight, getPortPosition, } from './utils';
import { getMapFromArrayOneToOne } from '../../utils/util';
const PIXELS = {
    US_VERTICAL_SPLIT_PHASE: {
        panelContainerWidth: 500,
        panelWidth: 366,
        energyProOffset: 210,
        mainBreakerOffset: 140.5,
        energyDeviceBus2Offset: 450,
        energyProMainBreakerWireStart: 220,
        energyProBus1WireStart: 265,
        energyProBus2WireStart: 273,
        energyProBus2WireEnd: 475,
        breakerWireRightToLeftOffset: 385,
    },
    US_VERTICAL_THREE_PHASE: {
        panelContainerWidth: 650,
        panelWidth: 512,
        energyProOffset: 282,
        mainBreakerOffset: 213.5,
        energyProMainBreakerWireStart: 292,
        energyDeviceBus2Offset: 596,
        energyProBus1WireStart: 336,
        energyProBus2WireStart: 344,
        energyProBus2WireEnd: 621,
        breakerWireRightToLeftOffset: 525,
    },
};
function getConnectedDevices(busDevice) {
    function* getConnectedDevice(busDevice) {
        if (!busDevice) {
            return;
        }
        yield busDevice;
        if (!busDevice.busDevice) {
            return;
        }
        yield* getConnectedDevice(busDevice.busDevice);
    }
    const it = getConnectedDevice(busDevice);
    let res = it.next();
    let ids = [];
    while (!res.done) {
        ids.push(res.value.id);
        res = it.next();
    }
    return ids;
}
function getStartArc(isLeftToRight, isTopToBottom) {
    if (isLeftToRight && isTopToBottom) {
        return {
            offsetStartX: -10,
            offsetStartY: -10,
            startArc: 'a10,10 0 0 1 10,10',
        };
    }
    if (isLeftToRight === false && isTopToBottom) {
        return {
            offsetStartX: 10,
            offsetStartY: -10,
            startArc: 'a10,10 0 0 0 -10,10',
        };
    }
    if (isLeftToRight && isTopToBottom === false) {
        return {
            offsetStartX: -10,
            offsetStartY: 10,
            startArc: 'a10,10 0 0 0 10,-10',
        };
    }
    if (isLeftToRight === false && isTopToBottom === false) {
        return {
            offsetStartX: 10,
            offsetStartY: 10,
            startArc: 'a10,10 0 0 1 -10,-10',
        };
    }
    return { offsetStartX: 0, offsetStartY: 0, startArc: '' };
}
function getEndArc(isLeftToRight, isTopToBottom) {
    if (isLeftToRight && isTopToBottom) {
        return {
            offsetEndX: 10,
            offsetEndY: -10,
            endArc: 'a10,10 0 0 0 10,10',
        };
    }
    if (isLeftToRight === false && isTopToBottom) {
        return {
            offsetEndX: 10,
            offsetEndY: -10,
            endArc: 'a10,10 0 0 1 -10,10',
        };
    }
    if (isLeftToRight && isTopToBottom === false) {
        return {
            offsetEndX: 10,
            offsetEndY: 10,
            endArc: 'a10,10 0 0 1 10,-10',
        };
    }
    if (isLeftToRight === false && isTopToBottom === false) {
        return { offsetEndX: 10, offsetEndY: 10, endArc: 'a10,10 0 0 0 -10,-10' };
    }
    return { offsetEndX: 0, offsetEndY: 0, endArc: '' };
}
export const CircuitBreakerPosition = (props) => {
    const { slotPosition, column, children } = props;
    const { x, y } = getBreakerPosition(column, slotPosition);
    return _jsx("g", Object.assign({ transform: `translate(${x}, ${y})` }, { children: children }), void 0);
};
function BreakerCell(props) {
    return (_jsx("rect", Object.assign({ x: "1", y: "1", height: "26", width: "122", className: styles.cell }, props), void 0));
}
function BusDevice(props) {
    const { resourceType, title, sensors, reversed, id, onEnergyDeviceClick, selectedEnergyDevice, isHighlighted, } = props;
    switch (resourceType) {
        case 'Energy Bar':
            return (_jsx(EnergyBar, { reversed: reversed, isHighlighted: isHighlighted, title: title, activePorts: sensors.map((s) => s.port), onEnergyDeviceClick: (port) => onEnergyDeviceClick(id, port), isEnergyDeviceSelected: id === selectedEnergyDevice.id, selectedEnergyDevicePort: selectedEnergyDevice.energyDevicePort }, void 0));
        case 'Energy Spider':
            return (_jsx(EnergySpider, { reversed: reversed, isHighlighted: isHighlighted, title: title, activePorts: sensors.map((s) => s.port), onEnergyDeviceClick: (port) => onEnergyDeviceClick(id, port), isEnergyDeviceSelected: id === selectedEnergyDevice.id, selectedEnergyDevicePort: selectedEnergyDevice.energyDevicePort }, void 0));
        case 'Energy Spider Flex':
            return (_jsx(EnergySpiderFlex, { reversed: reversed, isHighlighted: isHighlighted, title: title, activePorts: sensors.map((s) => s.port), onEnergyDeviceClick: (port) => onEnergyDeviceClick(id, port), isEnergyDeviceSelected: id === selectedEnergyDevice.id, selectedEnergyDevicePort: selectedEnergyDevice.energyDevicePort }, void 0));
        default:
            return null;
    }
}
function ConnectedBreakerWire({ from, to, port, isHighlighted, onBreakerWireClick, panelType, }) {
    const endX = to.x - from.x;
    const endY = to.y - from.y;
    const isLeftToRight = endX > 0;
    const isTopToBottom = endY > 0;
    const portDelta = isLeftToRight ? port * -5 : port * 5;
    const wireLaneStart = isLeftToRight
        ? 115
        : PIXELS[panelType].breakerWireRightToLeftOffset;
    function getLine() {
        const { offsetStartX, offsetStartY, startArc } = getStartArc(isLeftToRight, isTopToBottom);
        const { offsetEndY, endArc } = getEndArc(isLeftToRight, isTopToBottom);
        return `h${wireLaneStart - from.x + portDelta + offsetStartX} ${startArc} v${endY + offsetStartY + offsetEndY} ${endArc}`;
    }
    return (_jsx("path", { fill: "none", strokeWidth: "2", strokeLinecap: "square", d: `M${from.x} ${from.y} ${getLine()} L${to.x} ${to.y}`, className: `${styles.wire} ${isHighlighted ? styles.highlightedWire : ''}`, onClick: (e) => {
            e.stopPropagation();
            onBreakerWireClick();
        } }, void 0));
}
function EnergyProWire({ from, to, isHighlighted, onClick }) {
    const endX = to.x - from.x;
    const isLeftToRight = endX > 0;
    const middle = (to.y - from.y) / 2 - 20;
    const middleArc = isLeftToRight
        ? 'a20,20 0 0 0 20,20'
        : 'a20,20 0 0 1 -20,20';
    const endArc = isLeftToRight ? 'a20,20 0 0 1 20,20' : 'a20,20 0 0 0 -20,20';
    const verticalShift = isLeftToRight ? 40 : -40;
    return (_jsx("path", { fill: "none", strokeWidth: "2", d: `M${from.x} ${from.y} v${middle} ${middleArc} h${endX - verticalShift} ${endArc} L${to.x} ${to.y}`, className: `${styles.wire} ${isHighlighted ? styles.highlightedWire : ''}`, strokeLinecap: "square", onClick: (e) => {
            e.stopPropagation();
            onClick();
        } }, void 0));
}
function MainWire({ port, breakerPole, isHighlighted, mainBreakerPoles, panelType, }) {
    const index = port - 1;
    const breakerPoleIndex = breakerPole - 1;
    const mainBreakerDoublePoleOffset = 35;
    const mainBreakerThreePoleOffset = 20;
    const offset = mainBreakerPoles === 2
        ? mainBreakerDoublePoleOffset
        : mainBreakerThreePoleOffset;
    return (_jsx("path", { fill: "none", strokeWidth: "2", className: `${styles.wire} ${isHighlighted ? styles.highlightedWire : ''}`, d: `M${PIXELS[panelType].energyProMainBreakerWireStart + index * 6} 32 v-6 a10,10 0 0 0 -10,-10 h-${20 + index * 6} a10,10 0 0 0 -10,10 v133 a10,10 0 0 0 10,10 h${offset + breakerPoleIndex * 28.33} a10,10 0 0 1 10,10 v14`, strokeLinecap: "square" }, void 0));
}
const RowNumbers = ({ rows = [], panelType = 'US_VERTICAL_SPLIT_PHASE', }) => {
    const renderSecondRowNumberColumn = panelType === 'US_VERTICAL_THREE_PHASE';
    const renderText = (i, columnNum) => {
        return (_jsx("text", Object.assign({ transform: `translate(${columnNum === 1 ? '126' : '267'}, ${i * 30 * 5 - 13})`, className: styles.rowNumber }, { children: _jsx("tspan", { children: (i * 5).toString().padStart(2, '0') }, void 0) }), void 0));
    };
    return (_jsx(_Fragment, { children: rows
            .filter((_, i) => i % 5 === 0)
            .map((_, i) => (_jsxs(React.Fragment, { children: [renderText(i + 1, 1), renderSecondRowNumberColumn && renderText(i + 1, 2)] }, `RowNumber${(i + 1) * 5}`))) }, void 0));
};
function DevicePosition(props) {
    const { id, setPositions, index, offsetX = 0, nextId, resourceType } = props;
    const x = offsetX;
    const y = index * 140;
    useEffect(() => {
        const height = getDeviceHeight(resourceType);
        setPositions((prevState) => (Object.assign(Object.assign({}, prevState), { [id]: { id, x, y, height, nextId } })));
        return () => setPositions((prevState) => (Object.assign(Object.assign({}, prevState), { [id]: {
                x: undefined,
                y: undefined,
                height: undefined,
                nextId: undefined,
            } })));
    }, [setPositions, id, index, nextId, offsetX, resourceType, x, y]);
    return _jsx("g", Object.assign({ transform: `translate(${x}, ${y})` }, { children: props.children }), void 0);
}
export const DistributionPanel = ({ breakerSlots, breakerColumns, breakers, mainBreaker, energyPro, energyProId, firstBusConnection, secondBusConnection, energyDevicesById = {}, breakersById = {}, energyReadingsBySensorId = {}, onCircuitBreakerClick, onPanelMainBreakerClick, onEnergyDeviceClick, onEnergyProClick, onBreakerWireClick, selectedResourceId, selectedEnergyDevice, selectedBreakerWire, }) => {
    const panelType = breakerColumns === 3
        ? 'US_VERTICAL_THREE_PHASE'
        : 'US_VERTICAL_SPLIT_PHASE';
    const rows = Array.from(new Array(breakerSlots));
    const columns = Array.from(new Array(breakerColumns));
    const height = (21.25 + 2.125 * rows.length) * 16;
    const [positions, setPositions] = useState({});
    const [connections, setConnections] = useState({});
    const [connectedBreakers, setConnectedBreakers] = useState(new Map());
    const [firstBusDeviceIds, setFirstBusDeviceIds] = useState([]);
    const [secondBusDeviceIds, setSecondBusDeviceIds] = useState([]);
    const sensorsById = useMemo(() => {
        let sensorsArray = [];
        if (!energyPro)
            return undefined;
        const energyProSensors = energyPro.sensors || [];
        const recursivelyGetSensors = (energyDevice) => {
            if (!energyDevice)
                return;
            if (energyDevice.sensors) {
                sensorsArray = sensorsArray.concat(energyDevice.sensors);
            }
            if (energyDevice.busDevice) {
                recursivelyGetSensors(energyDevice.busDevice);
            }
        };
        recursivelyGetSensors(energyPro.bus1Device);
        recursivelyGetSensors(energyPro.bus2Device);
        sensorsArray = [...sensorsArray, ...energyProSensors];
        return getMapFromArrayOneToOne(sensorsArray);
    }, [energyPro]);
    const processedEnergyReadingsBySensorId = useMemo(() => {
        return Object.values(energyReadingsBySensorId).map((sensorReading) => {
            const sensor = sensorsById === null || sensorsById === void 0 ? void 0 : sensorsById[sensorReading.id];
            return Object.assign(Object.assign({}, sensorReading), { breakerId: sensor === null || sensor === void 0 ? void 0 : sensor.breakerId, breakerPole: sensor === null || sensor === void 0 ? void 0 : sensor.breakerPole });
        });
    }, [energyReadingsBySensorId, sensorsById]);
    useEffect(() => {
        setFirstBusDeviceIds(getConnectedDevices(firstBusConnection));
    }, [firstBusConnection]);
    useEffect(() => {
        setSecondBusDeviceIds(getConnectedDevices(secondBusConnection));
    }, [secondBusConnection]);
    useEffect(() => {
        let connections = {};
        let connectedBreakers = new Map();
        firstBusDeviceIds.forEach((id, index) => {
            const energyDevice = energyDevicesById[id];
            if (!energyDevice) {
                return;
            }
            energyDevice.sensors.forEach((sensor) => {
                const connectionKey = `${id.toString()}_${sensor.breakerId.toString()}_${sensor.port.toString()}`;
                const breaker = breakersById[sensor.breakerId] || sensor.breaker;
                connectedBreakers.set(sensor.breakerId, true);
                connections[connectionKey] = {
                    id: connectionKey,
                    from: {
                        id,
                        resourceType: energyDevicesById[id].resourceType,
                        column: 0,
                        index,
                        port: sensor.port,
                    },
                    to: {
                        id: sensor.breakerId,
                        column: breaker.breakerColumn,
                        index: breaker.breakerSlotPosition,
                        pole: sensor.breakerPole,
                    },
                    reversed: false,
                };
            });
        });
        secondBusDeviceIds.forEach((id, index) => {
            const energyDevice = energyDevicesById[id];
            if (!energyDevice) {
                return;
            }
            energyDevice.sensors.forEach((sensor) => {
                const connectionKey = `${id.toString()}_${sensor.breakerId.toString()}_${sensor.port.toString()}`;
                const breaker = breakersById[sensor.breakerId] || sensor.breaker;
                connectedBreakers.set(sensor.breakerId, true);
                connections[connectionKey] = {
                    id: connectionKey,
                    from: {
                        id,
                        resourceType: energyDevicesById[id].resourceType,
                        column: 2,
                        index,
                        port: sensor.port,
                    },
                    to: {
                        id: sensor.breakerId,
                        column: breaker.breakerColumn,
                        index: breaker.breakerSlotPosition,
                        pole: sensor.breakerPole,
                    },
                    reversed: true,
                };
            });
        });
        setConnections(connections);
        setConnectedBreakers(connectedBreakers);
    }, [
        setConnectedBreakers,
        setConnections,
        firstBusDeviceIds,
        secondBusDeviceIds,
        energyDevicesById,
        breakersById,
        energyProId,
    ]);
    const determineBreakerState = (breakerId) => {
        if (String(breakerId) === String(selectedResourceId) ||
            (selectedBreakerWire === null || selectedBreakerWire === void 0 ? void 0 : selectedBreakerWire.breakerId) === breakerId ||
            Object.values(connections)
                .filter((c) => c.to.id === breakerId)
                .find((c) => c.from.id === selectedResourceId)) {
            return 'selected';
        }
        if (connectedBreakers.has(breakerId))
            return 'connected';
        return 'default';
    };
    const determineMainBreakerConnectedPoles = () => {
        const connectedMainBreakerPoles = [];
        if (energyPro) {
            energyPro.sensors.forEach((s) => connectedMainBreakerPoles.push(s.breakerPole));
        }
        Object.values(energyDevicesById).forEach((energyDevice) => {
            energyDevice.sensors.forEach((s) => {
                if (s.breaker._entity === 'MainBreaker') {
                    connectedMainBreakerPoles.push(s.breakerPole);
                }
            });
        });
        return connectedMainBreakerPoles;
    };
    return (_jsxs("svg", Object.assign({ className: styles.root, height: height, width: PIXELS[panelType].panelContainerWidth, xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, { children: [_jsx("g", Object.assign({ id: "energyPro", transform: `translate(${PIXELS[panelType].energyProOffset}, 32)` }, { children: energyPro && (_jsx(EnergyPro, { bus1Device: energyPro.bus1Device !== null, bus2Device: energyPro.bus2Device !== null, activePorts: energyPro.sensors.map((s) => s.port), onEnergyProClick: (energyProPort) => {
                        if (onEnergyProClick) {
                            return onEnergyProClick(energyPro.id, energyProPort);
                        }
                    }, isHighlighted: String(selectedResourceId) === String(energyPro.id) ||
                        String(mainBreaker.id) === String(selectedResourceId), isEnergyDeviceSelected: energyPro.id === (selectedEnergyDevice === null || selectedEnergyDevice === void 0 ? void 0 : selectedEnergyDevice.id), selectedEnergyDevicePort: selectedEnergyDevice === null || selectedEnergyDevice === void 0 ? void 0 : selectedEnergyDevice.energyDevicePort }, energyPro.id.toString())) }), void 0), firstBusConnection && (_jsx(EnergyProWire, { from: { x: PIXELS[panelType].energyProBus1WireStart, y: 88 }, to: { x: 25, y: 180 }, isHighlighted: selectedResourceId === energyProId, onClick: () => {
                    if (onEnergyProClick) {
                        onEnergyProClick(energyPro.id);
                    }
                } }, void 0)), secondBusConnection && (_jsx(EnergyProWire, { from: { x: PIXELS[panelType].energyProBus2WireStart, y: 101 }, to: { x: PIXELS[panelType].energyProBus2WireEnd, y: 180 }, isHighlighted: selectedResourceId === energyProId, onClick: () => {
                    if (onEnergyProClick) {
                        onEnergyProClick(energyPro.id);
                    }
                } }, void 0)), _jsxs("g", Object.assign({ id: "panel", transform: "translate(65, 160)" }, { children: [_jsx("rect", { className: styles.panel, x: 2, y: 2, height: height - 164, width: PIXELS[panelType].panelWidth, rx: "20", ry: "20" }, void 0), _jsx("g", Object.assign({ id: "panelMainBreaker", transform: `translate(${PIXELS[panelType].mainBreakerOffset}, 4)` }, { children: _jsx(DistributionPanelMainBreaker, { siteTotal: mainBreaker.siteTotal, state: determineBreakerState(mainBreaker.id), mainBreakerPoles: mainBreaker.poles, connectedBreakerPoles: determineMainBreakerConnectedPoles(), onPanelMainBreakerClick: (breakerPole) => {
                                if (onPanelMainBreakerClick) {
                                    onPanelMainBreakerClick(Number(mainBreaker.id), Number(breakerPole));
                                }
                            }, isEnergyDevicePortSelected: (selectedEnergyDevice === null || selectedEnergyDevice === void 0 ? void 0 : selectedEnergyDevice.id) !== -1 &&
                                (selectedEnergyDevice === null || selectedEnergyDevice === void 0 ? void 0 : selectedEnergyDevice.energyDevicePort) !== -1, energyReadings: Object.values(processedEnergyReadingsBySensorId).filter((s) => s.breakerId === mainBreaker.id) }, void 0) }), void 0), _jsxs("g", Object.assign({ transform: "translate(54, 160)" }, { children: [columns.map((_, c) => (_jsx("g", { children: rows.map((_, r) => (_jsx(BreakerCell, { transform: `translate(${c * 140}, ${r * 30})` }, r.toString()))) }, c.toString()))), _jsx(RowNumbers, { rows: rows, panelType: panelType }, void 0), breakers.map((breaker) => (_jsx(CircuitBreakerPosition, Object.assign({ slotPosition: breaker.breakerSlotPosition, column: breaker.breakerColumn, size: breaker.breakerSlots.length }, { children: _jsx(CircuitBreaker, { onCircuitBreakerClick: (breakerId, breakerPole) => {
                                        if (onCircuitBreakerClick) {
                                            onCircuitBreakerClick(breaker.breaker.id, breakerPole);
                                        }
                                    }, title: breaker.breaker.title, rating: breaker.breaker.rating, id: breaker.breaker.id, type: breaker.breaker.type, siteTotal: breaker.breaker.siteTotal, hasEquipment: !!breaker.breaker.equipmentId, energyReadings: Object.values(processedEnergyReadingsBySensorId).filter((s) => s.breakerId === breaker.breaker.id), subpanel: breaker.breaker.subpanel, reversed: breaker.breakerColumn > 1, state: determineBreakerState(breaker.breaker.id), isEnergyDevicePortSelected: (selectedEnergyDevice === null || selectedEnergyDevice === void 0 ? void 0 : selectedEnergyDevice.id) !== energyProId &&
                                        (selectedEnergyDevice === null || selectedEnergyDevice === void 0 ? void 0 : selectedEnergyDevice.energyDevicePort) !== -1, connectedPoles: Object.values(connections)
                                        .filter((c) => c.to.id === breaker.breaker.id)
                                        .map((c) => c.to.pole) }, void 0) }), breaker.breaker.id.toString())))] }), void 0)] }), void 0), energyPro &&
                energyPro.sensors.map((s, index) => (_jsx(MainWire, { mainBreakerPoles: mainBreaker.poles, port: s.port, breakerPole: s.breakerPole, isHighlighted: String(energyProId) === String(selectedResourceId) ||
                        String(mainBreaker.id) === String(selectedResourceId), panelType: panelType }, `mainBreakerWire${index + 1}`))), _jsxs("g", Object.assign({ transform: "translate(0, 180)" }, { children: [firstBusDeviceIds.map((id, index, array) => {
                        const device = energyDevicesById[id];
                        return (_jsx(DevicePosition, Object.assign({ id: id, index: index, setPositions: setPositions, nextId: array[index + 1] }, device, { children: _jsx(BusDevice, Object.assign({}, device, { onEnergyDeviceClick: (energyDeviceId, energyDevicePort) => {
                                    if (onEnergyDeviceClick) {
                                        onEnergyDeviceClick(energyDeviceId, energyDevicePort);
                                    }
                                }, selectedEnergyDevice: selectedEnergyDevice, isHighlighted: selectedResourceId === id ||
                                    selectedResourceId === energyProId ||
                                    (selectedBreakerWire === null || selectedBreakerWire === void 0 ? void 0 : selectedBreakerWire.energyDeviceId) === id ||
                                    (device &&
                                        device.sensors &&
                                        device.sensors
                                            .map((s) => s.breaker.id)
                                            .includes(selectedResourceId)) }), void 0) }), id.toString()));
                    }), secondBusDeviceIds.map((id, index, array) => {
                        const device = energyDevicesById[id];
                        return (_jsx(DevicePosition, Object.assign({ id: id, offsetX: PIXELS[panelType].energyDeviceBus2Offset, index: index, setPositions: setPositions, nextId: array[index + 1] }, device, { children: _jsx(BusDevice, Object.assign({}, device, { reversed: true, onEnergyDeviceClick: (energyDeviceId, energyDevicePort) => {
                                    if (onEnergyDeviceClick) {
                                        onEnergyDeviceClick(energyDeviceId, energyDevicePort);
                                    }
                                }, selectedEnergyDevice: selectedEnergyDevice, isHighlighted: selectedResourceId === id ||
                                    selectedResourceId === energyProId ||
                                    (selectedBreakerWire === null || selectedBreakerWire === void 0 ? void 0 : selectedBreakerWire.energyDeviceId) === id ||
                                    (device &&
                                        device.sensors
                                            .map((s) => s.breaker.id)
                                            .includes(selectedResourceId)) }), void 0) }), id.toString()));
                    })] }), void 0), _jsx("g", Object.assign({ id: "connections", transform: "translate(0, 180)" }, { children: Object.values(connections).map((connection) => {
                    const device = positions[connection.from.id];
                    const isMainBreaker = !connection.to.column && !connection.to.index;
                    if (!device) {
                        return null;
                    }
                    const portPosition = getPortPosition(connection.from, connection.reversed);
                    const from = {
                        x: portPosition.x + device.x,
                        y: portPosition.y + device.y,
                    };
                    const breakerPolePosition = isMainBreaker
                        ? getMainBreakerPolePosition(connection.to.pole, panelType)
                        : getBreakerPolePosition(connection.to.column, connection.to.index, connection.to.pole);
                    return (_jsx(ConnectedBreakerWire, { isHighlighted: connection.to.id === selectedResourceId ||
                            connection.from.id === selectedResourceId ||
                            connection.id ===
                                `${selectedBreakerWire === null || selectedBreakerWire === void 0 ? void 0 : selectedBreakerWire.energyDeviceId}_${selectedBreakerWire === null || selectedBreakerWire === void 0 ? void 0 : selectedBreakerWire.breakerId}_${selectedBreakerWire === null || selectedBreakerWire === void 0 ? void 0 : selectedBreakerWire.energyDevicePort}`, from: from, to: {
                            x: breakerPolePosition.x + 54 + (isMainBreaker ? 0 : 65),
                            y: breakerPolePosition.y + (isMainBreaker ? 0 : 140),
                        }, port: connection.from.port, onBreakerWireClick: () => {
                            if (onBreakerWireClick) {
                                onBreakerWireClick(connection.to.id, connection.from.id, connection.from.port);
                            }
                        }, panelType: panelType }, `connection${connection.id.toString()}`));
                }) }), void 0), _jsx("g", Object.assign({ id: "deviceConnections", transform: "translate(0, 180)" }, { children: Object.values(positions).map((d) => {
                    if (!d.nextId) {
                        return null;
                    }
                    return (_jsx("path", { d: `M${d.x + 25} ${d.y + d.height} v${140 - d.height}`, fill: "none", strokeWidth: "2", stroke: "var(--accent-basePlus25)", opacity: selectedResourceId === energyProId ? '1' : '0.1' }, `${d.id.toString()}Connection`));
                }) }), void 0)] }), void 0));
};
export default DistributionPanel;
